import { useCallback, useMemo, useState } from "react";
import { TabsContext } from "./tabs.context";

import type { ReactNode } from "react";
import type { Tab } from "./tabs.context";
import type { Optional } from "../../../types";

export type TabsProviderProps = {
  children: ReactNode;
  value?: Optional<string>;
  onTabChange?: (name: string) => void;
};

export function TabsProvider({
  children,
  value,
  onTabChange,
}: Readonly<TabsProviderProps>) {
  const [tabs, setTabs] = useState<Tab[]>([]);

  const activeTab = useMemo(() => {
    return tabs.find((tab) => tab.name === value);
  }, [tabs, value]);

  const isActive = useCallback(
    (name: string) => {
      return name === activeTab?.name;
    },
    [activeTab]
  );

  const handleChange = useCallback(
    (name: string) => {
      if (onTabChange) {
        onTabChange(name);
      }
    },
    [onTabChange]
  );

  const providerValue = useMemo(() => {
    return {
      tabs,
      isActive: isActive,
      setTabs,
      activeTab: activeTab,
      handleChange,
    };
  }, [tabs, isActive, activeTab, handleChange]);

  return (
    <TabsContext.Provider value={providerValue}>
      {children}
    </TabsContext.Provider>
  );
}
